import React from "react";
import { Label } from "./ui/label";
import { Button } from "./ui/button";

export const DIAS_SEMANA = [
  { key: "seg", label: "Seg" },
  { key: "ter", label: "Ter" },
  { key: "qua", label: "Qua" },
  { key: "qui", label: "Qui" },
  { key: "sex", label: "Sex" },
  { key: "sab", label: "Sáb" },
  { key: "dom", label: "Dom" },
];

const PRESETS = {
  seg_sex: ["seg", "ter", "qua", "qui", "sex"],
  seg_sab: ["seg", "ter", "qua", "qui", "sex", "sab"],
  todos: ["seg", "ter", "qua", "qui", "sex", "sab", "dom"],
};

export const gradePadrao = (horarios) =>
  Object.fromEntries(DIAS_SEMANA.map((d) => [d.key, PRESETS.seg_sex.includes(d.key) ? [...horarios] : []]));

export const gradeDoItem = (item) => {
  const horarios = item.horarios_verificacao || [];
  if (!item.horarios_por_dia) return gradePadrao(horarios);
  return Object.fromEntries(
    DIAS_SEMANA.map((d) => [d.key, horarios.filter((h) => (item.horarios_por_dia[d.key] || []).includes(h))])
  );
};

export const GradeDiasVerificacao = ({ horarios, grade, onChange }) => {
  const toggle = (dia, horario) => {
    const atual = grade[dia] || [];
    const novo = atual.includes(horario) ? atual.filter((h) => h !== horario) : [...atual, horario];
    onChange({ ...grade, [dia]: novo });
  };

  const aplicarPreset = (preset) =>
    onChange(Object.fromEntries(DIAS_SEMANA.map((d) => [d.key, PRESETS[preset].includes(d.key) ? [...horarios] : []])));

  const diaAtivo = (dia) => (grade[dia] || []).length > 0;

  return (
    <div className="space-y-3" data-testid="grade-dias-verificacao">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <Label>Dias e horários de funcionamento</Label>
        <div className="flex gap-1">
          <Button type="button" size="sm" variant="outline" className="h-7 text-xs bg-white" onClick={() => aplicarPreset("seg_sex")} data-testid="preset-seg-sex">Seg–Sex</Button>
          <Button type="button" size="sm" variant="outline" className="h-7 text-xs bg-white" onClick={() => aplicarPreset("seg_sab")} data-testid="preset-seg-sab">Seg–Sáb</Button>
          <Button type="button" size="sm" variant="outline" className="h-7 text-xs bg-white" onClick={() => aplicarPreset("todos")} data-testid="preset-todos">Todos os dias</Button>
        </div>
      </div>
      <p className="text-xs text-amber-700">
        Desmarque os horários em que a farmácia está fechada (ex.: sábado à tarde). Dias sem nenhum horário marcado não geram verificação.
      </p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm bg-white rounded-md border border-amber-200">
          <thead>
            <tr className="bg-amber-100/60 text-amber-900">
              <th className="text-left px-3 py-2 font-medium">Dia</th>
              {horarios.map((h, idx) => (
                <th key={idx} className="px-2 py-2 font-medium text-center">{h || `${idx + 1}ª`}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {DIAS_SEMANA.map((d) => (
              <tr key={d.key} className={`border-t border-amber-100 ${diaAtivo(d.key) ? "" : "text-slate-400"}`} data-testid={`grade-dia-${d.key}`}>
                <td className="px-3 py-1.5 font-medium">{d.label}</td>
                {horarios.map((h, idx) => (
                  <td key={idx} className="px-2 py-1.5 text-center">
                    <input
                      type="checkbox"
                      className="h-4 w-4 accent-emerald-600 cursor-pointer"
                      checked={(grade[d.key] || []).includes(h)}
                      onChange={() => toggle(d.key, h)}
                      disabled={!h}
                      data-testid={`grade-${d.key}-${idx}`}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
